export default {
  methods: {
    getPageSizes(totalItems, pageSizes = [10, 20, 50, 100]) {
      const sizes = pageSizes.filter(size => size <= totalItems);
      const upperSize = pageSizes[sizes.length]; // the next item in pageSizes

      // adding a higher size to the list of pageSizes if there is any
      if (
        !sizes.length ||
        (totalItems > sizes[sizes.length - 1] && upperSize)
      ) {
        sizes.push(upperSize);
      }

      return sizes;
    },
  },
};
